// extracted by mini-css-extract-plugin
module.exports = {"waveform":"TrackWaveform_waveform__lkfcY"};